module.exports = __webpack_public_path__ + "img/fbbf411.png";